import styled from "styled-components"
import { mobile, tablet } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
    margin-top: 60px;
    min-height: 85vh;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${tablet({ marginTop: "30px"})}
    ${mobile({ padding: "10px"})}
`

export const Title = styled.h1`
    margin: 20px;
    display: flex;
    align-items: center;
    text-align: center;

    ${mobile({ margin: "10px" })}
`

export const Text = styled.p`
`
export const SearchContainer = styled.div`
    border: 0.5px solid var(--medGrey);
    font-size: var(--fontS);
    display: flex;
    align-items: center;
    padding: 5px;
    margin: 10px 0px;
`

export const Input = styled.input`
    background-color: transparent;
    color: var(--darkGrey);
    border: none;
    width: 200px;

    ::placeholder { 
        color: var(--medGrey);
    }

    :focus{
        outline: none;
    }
`

export const List = styled.ul`
    list-style: none;
    padding-left: 0;
    margin: 10px 0px;
`

export const ListItem = styled.li`
    marginBottom: 0.5rem;
    cursor: pointer;
    list-style-type: none;
`